export default {
  title: 'Wyprzedane produkty',
  sections: {
    settings: 'Ustawienia',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Wyprzedane produkty są automatycznie oznaczane jako dostępne na koniec dnia.',
        manual_reset: 'Personel musi ręcznie oznaczać produkty jako dostępne po oznaczeniu ich jako wyprzedane.',
      },
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
